ACC.newOrderReason = {
  orderreasonpage: '.ph-orderreasonpage',
  orderReasonId: '#orderReason',
  defaultloader: '.ph-loader__default',
  equipmentiPserialnumberIds: '#equipmentserialnumber,#iPserialnumber,#validEquipmentNumber',
  displayblock: 'ph-d-block',
  displaynone: 'ph-d-none',
  smaxFlow: $('.ph-sso-seession').html(),
  selectedReasonType: '',
  isRefineSearch: false,
  serialNumberfieldlist: [
    'equipmentwarranty',
    'commercialdefoa',
    'tibaservicecontract',
    'pmscscontract',
    'indentcontract',
    'billed'
  ],
  bindAll: function() {
    $(document).on('click', '#orderReasonBtn', function() {
      ACC.newOrderReason.orderReasonValidations();
    });
    $(document).on('keydown', '#SPSOrderReasonForm', function(keyevent) {
      if (keyevent.which === 13 && keyevent.target.getAttribute('id') === 'systemnumber') {
        $('.ph-serialnumber_search').trigger('click');
        keyevent.preventDefault();
      } else if (keyevent.which === 13) {
        $('#orderReasonBtn').trigger('click');
        keyevent.preventDefault();
      }
    });
    $(document).on('click', '.ph-serialnumber_search', function() {
      if ($('#systemnumber').val() !== '' && $('.ph-isEmbargoCountry').text() !== 'true') {
        $('.ph-lookuperrordiv,.ph-entitlementByIp,.ip_display').addClass('hidden');
        ACC.newOrderReason.ipLookupCall();
      }
    });
    $(ACC.newOrderReason.orderReasonId).on('change', function() {
      ACC.newOrderReason.displayRespectiveFields();
      ACC.newOrderReason.orderReasonDropdownChange();
    });
    $(document).on('click', '.ph-orderreason__tooltip_icon', function() {
      $(this).find('.ph-orderreason__tooltip_text').toggleClass('hidden');
    });
    $(document).on('blur', '#otherdays', function() {
      ACC.newOrderReason.daysDropdownChange();
    });
    $('#numberofdays').on('change', function() {
      ACC.newOrderReason.daysDropdownChange();
    });
    $(ACC.newOrderReason.orderreasonpage).addClass('ph-orderreasonpagenew');
  },
  servicedefoaPopup: function(showpopupInput) {
    var showpopup = showpopupInput;

    if ($('#partsInvoice').val() === '' || $('#problemdescription').val() === '') {
      showpopup = true;
    }

    if ($('#getSpFile').val() === '' && !$('#getSpFile').attr('data-imagename')) {
      showpopup = true;
    }

    return showpopup;
  },
  commercialdefoaPopup: function(showpopupInput) {
    var showpopup = showpopupInput;

    if (($('#commercialsalesorder').val() === '' || $('#equipmentinvoicenumber').val() === '') &&
       $('#validEquipmentNumber').val() === '') {
      showpopup = true;
    }

    if ($('#problemdescription').val() === '') {
      showpopup = true;
    }

    if ($('#getSpFile').val() === '' && !$('#getSpFile').attr('data-imagename')) {
      showpopup = true;
    }

    return showpopup;
  },
  /* eslint-disable complexity */
  /* eslint-disable max-statements */
  decideShowingPopup: function(showpopupInput) {
    var orderReasonValue = ACC.newOrderReason.selectedReasonType,
        showpopup = showpopupInput,
        errorVal = 'Default',
        serialNeededfieldlist = [
          'equipmentwarranty',
          'tibaservicecontract',
          'pmscscontract',
          'indentcontract'
        ];

    if (orderReasonValue === 'missingincorrectshipment') {
      if ($('#partsInvoice').val() === '') {
        showpopup = true;
        errorVal = 'MissingShip';
      }
    }

    if (orderReasonValue === 'servicewarranty') {
      if ($('#invoicenumber').val() === '' || $('#problemdescription').val() === '') {
        showpopup = true;
      }

      if ($('#invoicenumber').val() === '') {
        errorVal = 'SerWarranty';
      }
    }

    if (orderReasonValue === 'servicedefoa') {
      showpopup = ACC.newOrderReason.servicedefoaPopup(showpopup);

      if (showpopup === true && $('#partsInvoice').val() === '') {
        errorVal = 'SerDefoa';
      }
    }

    if (orderReasonValue === 'commercialdefoa') {
      showpopup = ACC.newOrderReason.commercialdefoaPopup(showpopup);

      if (showpopup === true && $('#validEquipmentNumber').val() !== '') {
        errorVal = 'ComDefoa';
      }

      if ($('#commercialsalesorder').val() === '' &&
       $('#equipmentinvoicenumber').val() === '' &&
       $('#validEquipmentNumber').val() === '') {
        errorVal = 'ComDefoa2';
        showpopup = true;
      }
    }

    if (serialNeededfieldlist.includes(orderReasonValue) &&
        $('#validEquipmentNumber').val() === '' &&
        $('#systemnumber').val() !== '') {
      showpopup = true;
      errorVal = 'SerialNumInvalid';
    }

    if (serialNeededfieldlist.includes(orderReasonValue) && $('#systemnumber').val() === '') {
      showpopup = true;
      errorVal = 'SerialNumEmpty';
    }

    if ($('.ph-isEmbargoCountry').text() === 'true' &&
       (errorVal === 'SerialNumInvalid' || errorVal === 'SerialNumEmpty')) {
      showpopup = false;
    }

    ACC.newOrderReason.orderReasonPopupMessage(errorVal);

    return showpopup;
  },
  /* eslint-enable max-statements */
  /* eslint-enable complexity */
  orderReasonBtnValidations: function() {
    var returnValue = false,
        showpopup = false;

    if (ACC.newOrderReason.selectedReasonType === '') {
      $('.field_orderreason .ph-form__fieldwrap').addClass('ph-form_field_error');
    } else {
      $('.field_orderreason .ph-form__fieldwrap').removeClass('ph-form_field_error');
      returnValue = true;
    }

    if (ACC.newOrderReason.smaxFlow !== 'true') {
      showpopup = ACC.newOrderReason.decideShowingPopup(showpopup);
    }

    if (showpopup === true) {
      returnValue = false;
      ACC.newOrderReason.orderReasonPopup();
    }

    return returnValue;
  },

  orderReasonValidations: function() {
    var formValidated = ACC.newOrderReason.orderReasonBtnValidations(),
        $orderReasonSmall = $('#orderReason option:selected').attr('data-smallValue');

    if (formValidated === true) {
      if (ACC.newOrderReason.smaxFlow === 'true') {
        $('#iPserialnumber').val($('#equipmentserialnumber').val());
      }

      ACC.orderReason.serialNumZeroOnLoad();
      $('#orderReasonSub').click();
      $(ACC.newOrderReason.defaultloader).show();

      ACC.omniture.bindTrackConversion('interaction', 'order_type:' + $orderReasonSmall);
    }
  },
  daysDropdownChange: function() {
    var $buttoninput = $('.ph-orderreason__submit > .ph-ordersubnitbtn'),
        daysVal = $('#numberofdays').val();

    $buttoninput.removeClass('ph-disabledbutton');

    $('.field_otherdays').addClass('hidden');

    if (daysVal === 'other') {
      $('.field_otherdays').removeClass('hidden');

      if ($('#otherdays').val() === '') {
        $buttoninput.addClass('ph-disabledbutton');
      }
    } else if (daysVal === '') {
      $buttoninput.addClass('ph-disabledbutton');
    } else {
      $('#otherdays').val(daysVal);
    }
  },
  orderReasonDropdownChange: function() {
    var orderReasonValue = ACC.newOrderReason.selectedReasonType,
        serialNumberfieldlist = ACC.newOrderReason.serialNumberfieldlist;

    $('.ph-orderTypeValue').text(orderReasonValue);
    $('.ph-lookuperrordiv').addClass('hidden');
    $('#systemnumber').val('');
    ACC.newOrderReason.isRefineSearch = false;
    ACC.newOrderReason.refineSearchProcess();

    if (orderReasonValue !== '' && ACC.newOrderReason.smaxFlow === 'true') {
      if (ACC.newOrderReason.isCourageAllowed() === true) {
        ACC.newOrderReason.ipLookupCall();
      }

      if (serialNumberfieldlist.includes(orderReasonValue)) {
        ACC.newOrderReason.displayIpTable();
      }
    }
  },
  afterCompletePageLoad: function() {
    var $orderReasonBackendValues = $('#orderReasonBackendValues'),
        orderReasonValue = $orderReasonBackendValues.attr('data-ordertype'),
        daysVal = $orderReasonBackendValues.attr('data-daysValue'),
        disableVal = $('#disableItems').attr('data-readonly'),
        disableTarget = $('#disableItems').attr('data-target'),
        orderReasonArray = ACC.orderReason.getOrderReasonArray();

    if (orderReasonValue) {
      var orderReasonSmall = orderReasonValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

      if ($.inArray(orderReasonSmall, orderReasonArray) !== -1) {
        var defaultValue = $(ACC.newOrderReason.orderReasonId).find('[data-smallValue="' + orderReasonSmall + '"]').val();

        $(ACC.newOrderReason.orderReasonId).val(defaultValue);
        ACC.orderReason.doSelectBoxRefresh();

        if (orderReasonSmall === 'toolrental') {
          $('#numberofdays').val(daysVal);

          if ($('.ph-orderreason-form').find('a.selectBox-dropdown').length > 0) {
            $('#numberofdays').selectBox('refresh');
          }

          ACC.newOrderReason.daysDropdownChange();
        }
      }

      $('.ph-orderTypeValue').text($(ACC.newOrderReason.orderReasonId).val());
    }

    if (disableVal === 'true') {
      $.each(disableTarget.split(','), function(k, v) {
        $('#' + v).prop('readonly', true);
      });
    }

    $('.ph-spinnerorder').removeClass(ACC.newOrderReason.displayblock).addClass(ACC.newOrderReason.displaynone);

    var fileName = $('.ph-file-input').attr('data-imageName');

    if (fileName) {
      $('.ph-orderreason_uploadfilename').html(fileName);
    }
  },
  /* eslint-disable max-statements */
  /* eslint-disable complexity */
  displayRespectiveFields: function() {
    var selectedClass = $(ACC.newOrderReason.orderReasonId).val(),
        serialNumberEnable = false,
        serialNumberfieldlist = ACC.newOrderReason.serialNumberfieldlist;

    if (selectedClass !== '') {
      selectedClass = selectedClass.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    }

    if (serialNumberfieldlist.includes(selectedClass)) {
      serialNumberEnable = true;
    }

    ACC.newOrderReason.selectedReasonType = selectedClass;
    $('.ph-inputwrap').addClass('hidden');
    $('.ph-neworderreason_title > p').addClass('hidden');
    $('.ph-servicewarranty_msg,.ph-servicedefoa_msg').addClass('hidden');
    $('.ph-equipmentinvoicenumber_message').addClass('hidden');
    $('.ph-partsinvoicemessage').addClass('hidden');

    var invoiceNumberDateMsg = $('.ph-invoiceNumberDateMsg').html();

    invoiceNumberDateMsg = invoiceNumberDateMsg.replace('{0}', $('#orderReason option:selected').text());
    $('.ph-invoiceNumberDateFieldMsg').html(invoiceNumberDateMsg);

    if (selectedClass === 'servicewarranty') {
      $('.field_invoicenumber').removeClass('hidden');
      $('.field_invoiceDate').removeClass('hidden');
      $('.field_problemDescription').removeClass('hidden');
      $('.ph-servicewarranty_msg').removeClass('hidden');
    }

    if (selectedClass === 'commercialdefoa') {
      $('.field_equipmentinvoicenumber').removeClass('hidden');
      $('.field_commercialsalesorder').removeClass('hidden');
      $('.field_problemDescription').removeClass('hidden');
      $('.field_getSpFile').removeClass('hidden');
      $('.ph-servicedefoa_msg').removeClass('hidden');
      $('.ph-equipmentinvoicenumber_message').removeClass('hidden');
    }

    if (selectedClass === 'servicedefoa') {
      //  $('.field_invoicenumber').removeClass('hidden');
      $('.field_partsInvoice').removeClass('hidden');
      $('.field_invoiceDate').removeClass('hidden');
      $('.field_problemDescription').removeClass('hidden');
      $('.field_getSpFile').removeClass('hidden');
      $('.ph-servicedefoa_msg').removeClass('hidden');
      $('.ph-partsinvoicemessage').addClass('hidden');
    }

    if (selectedClass === 'missingincorrectshipment') {
      $('.field_partsInvoice').removeClass('hidden');
      $('.ph-partsinvoicemessage').removeClass('hidden');
      $('.field_awb').removeClass('hidden');
    }

    if (selectedClass === 'toolrental') {
      $('.field_numberOfDays').removeClass('hidden');
      ACC.newOrderReason.daysDropdownChange();
    } else {
      $('.ph-orderreason__submit > .ph-ordersubnitbtn').removeClass('ph-disabledbutton');
    }

    if (selectedClass !== '') {
      $('.field_incidentNumber').removeClass('hidden');
    }

    if ($('#incidentNumber').val() === '') {
      $('#incidentNumber').removeClass('ph-field_readonly').removeAttr('readonly', 'readonly');
    } else if (ACC.newOrderReason.smaxFlow === 'true') {
      $('#incidentNumber').addClass('ph-field_readonly').attr('readonly', 'readonly');
    }

    if (selectedClass !== '' && serialNumberEnable === true && ACC.newOrderReason.smaxFlow !== 'true') {
      $('.field_systemnumber').removeClass('hidden');
    }
  },
  equipmentNumberCheck: function() {
    var equipmentNumber = '',
        eqSerNum = $('#equipmentserialnumber').val(),
        ipSerNum = $('#iPserialnumber').val();

    if (eqSerNum !== '' && eqSerNum !== '0') {
      equipmentNumber = eqSerNum;
    } else if (ipSerNum !== '' && ipSerNum !== '0') {
      equipmentNumber = ipSerNum;
    }

    return equipmentNumber;
  },
  /* eslint-enable max-statements */
  /* eslint-enable complexity */
  displayIpTable: function() {
    var equipmentNumber = ACC.newOrderReason.equipmentNumberCheck();

    if (equipmentNumber !== '') {
      $('.ip_display').removeClass('hidden');
      $('.iptable_equipnum').removeClass('ph-d-none hidden');
      $('.iptable_equipnum > .ph-iptable_right').html(equipmentNumber);
    }

    if ($('.iptable_serialnum > .ph-iptable_right').html() !== '' &&
     $('.iptable_serialnum > .ph-iptable_right').html() !== '0') {
      $('.ip_display').removeClass('hidden');
      $('.iptable_serialnum').removeClass('ph-d-none hidden');
    }

    if ($('.iptable_productnum > .ph-iptable_right').html() !== '') {
      $('.ip_display').removeClass('hidden');
      $('.iptable_productnum').removeClass('ph-d-none hidden');
    }

    if ($('.iptable_productdec > .ph-iptable_right').html() !== '') {
      $('.ip_display').removeClass('hidden');
      $('.iptable_productdec').removeClass('ph-d-none hidden');
    }
  },
  refineSearchProcess: function() {
    if (ACC.newOrderReason.isRefineSearch === true) {
      $('.field_sixnc,.field_systemdescription,.ph-ipLookuplabel').removeClass('hidden');
      $('.ph-serialNumlabel').addClass('hidden');
    } else {
      $('.field_sixnc,.field_systemdescription,.ph-ipLookuplabel').addClass('hidden');
      $('.ph-serialNumlabel').removeClass('hidden');
    }
  },
  ipLookupCall: function() {
    var ajaxPath = $('.ph-iplookup_url').val(),
        isValid = true,
        dataObj = {},
        errorIp = '.ph-ipLuperrormessage';

    if (ACC.newOrderReason.selectedReasonType === 'equipmentwarranty') {
      errorIp = '.ph-ipLuperrormessageEquip';
    } else if (ACC.newOrderReason.selectedReasonType === 'tibaservicecontract') {
      errorIp = '.ph-ipLuperrormessageTiba';
    }

    if (ACC.newOrderReason.smaxFlow !== 'true') {
      dataObj.systemnumber = $('#systemnumber').val();
    }

    if (ACC.newOrderReason.smaxFlow !== 'true' && ACC.newOrderReason.isRefineSearch === true) {
      dataObj.systemdescription = $.trim($('#systemdescription').val());
      dataObj.sixnc = $.trim($('#sixnc').val());
    }

    if (isValid) {
      dataObj.orderreasontype = ACC.newOrderReason.selectedReasonType;
      $(ACC.newOrderReason.defaultloader).show();
      $.ajax({
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        url: ajaxPath,
        type: 'POST',
        data: JSON.stringify(dataObj),
        dataType: 'json',
        success: function(result) {
          $(ACC.newOrderReason.defaultloader).hide();
          ACC.newOrderReason.showEntitlementTable(result);

          if (result.installedProductNumber) {
            $(ACC.newOrderReason.equipmentiPserialnumberIds).val(result.installedProductNumber);
            $('#systemnumber').val(result.serialNo);
            $('#systemdescription').val(result.productDescription);
            $('#sixnc').val(result.productCode);
            $('.iptable_equipnum > .ph-iptable_right').html(result.installedProductNumber);
            $('.iptable_serialnum > .ph-iptable_right').html(result.serialNo);
            $('.iptable_productnum > .ph-iptable_right').html(result.productCode);
            $('.iptable_productdec > .ph-iptable_right').html(result.productDescription);
            ACC.newOrderReason.displayIpTable();
          } else if (result.errorMessage && ACC.newOrderReason.smaxFlow !== 'true') {
            ACC.orderReason.ipLookuperrorHandler(errorIp, result.errorMessage);
            $('#validEquipmentNumber').val('');

            if (result.errorMessage === 'text.iplookup.refinesearch') {
              ACC.newOrderReason.isRefineSearch = true;
              ACC.newOrderReason.refineSearchProcess();
            }
          }
        },
        error: function() {
          $(ACC.newOrderReason.defaultloader).hide();
        }
      });
    }
  },
  isCourageAllowed: function() {
    var orderReasontype = ACC.newOrderReason.selectedReasonType;

    if (orderReasontype !== '' && $('.ph-showCoverageDetails').text() === 'true' &&
     $('.ph-coverageOrderReason').html().indexOf(orderReasontype) >= 0) {
      return true;
    }

    return false;
  },
  showEntitlementTable: function(result) {
    if (ACC.newOrderReason.isCourageAllowed() === true) {
      if (result.coveragedetails && result.allpartsnotcovered !== 'true') {
        ACC.orderReason.entitlementResult(result.coveragedetails, 'entitlementByIp');
      } else if (result.allpartsnotcovered === 'true') {
        ACC.orderReason.scrollToResult('entitlementByIp', false);
      }
    }
  },
  orderReasonPopupMessage: function(errorVal) {
    var msg = $('.newOrderReasonPage_popupError' + errorVal).html();
    var notAllowedCheckout = [
      'SerialNumInvalid',
      'SerialNumEmpty',
      'MissingShip',
      'SerWarranty',
      'SerDefoa',
      'ComDefoa2'
    ];

    msg = msg.replace('{0}', $('#orderReason option:selected').text());

    $('.newOrderReasonPopupTitle').html(msg);
    $('.ph-popupbuttons_wrap > button').addClass('hidden');

    if (notAllowedCheckout.includes(errorVal)) {
      $('.ph-popupbuttons_wrap > .popupbuttons2').removeClass('hidden');
    } else {
      $('.ph-popupbuttons_wrap > .popupbuttons').removeClass('hidden');
    }
  },
  orderReasonPopup: function() {
    var popupWidth = '100%';

    if ($(window).width() < 768) {
      popupWidth = '90%';
    }

    $('.newOrderReasonOkBtn').click(function() {
      $.colorbox.close();
      ACC.orderReason.serialNumZeroOnLoad();

      if (ACC.newOrderReason.smaxFlow === 'true') {
        $('#iPserialnumber').val($('#equipmentserialnumber').val());
      }

      $('#orderReasonSub').click();
      $(ACC.newOrderReason.defaultloader).show();
    });
    $('.newOrderReasonCancelBtn').click(function() {
      $.colorbox.close();
    });

    $.colorbox({
      inline: true,
      href: '#newOrderReasonPopup',
      scrolling: false,
      height: 'auto',
      width: popupWidth,
      maxWidth: 500,
      overlayClose: true,
      fixed: true,
      close: '<button type=\'button\' class=\'ph-cbox-close hidden\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('#colorbox').css('border-radius', '3px');
      }
    });
  }
};
$(document).ready(function() {
  if ($(ACC.newOrderReason.orderreasonpage).length > 0 && $('.enableNewOrderReason').text() === 'true') {
    ACC.newOrderReason.bindAll();

    if ($('#invoicedate').length > 0) {
      ACC.datePicker.datePickerInit($('#invoicedate'));
    }
  }
});

if ($(ACC.newOrderReason.orderreasonpage).length > 0 && $('.enableNewOrderReason').text() === 'true') {
  $(window).on('load', function() {
    ACC.newOrderReason.afterCompletePageLoad();
    ACC.newOrderReason.displayRespectiveFields();

    if (ACC.newOrderReason.smaxFlow === 'true') {
      if (ACC.newOrderReason.isCourageAllowed() === true) {
        ACC.newOrderReason.ipLookupCall();
        ACC.newOrderReason.displayIpTable();
      } else if (ACC.newOrderReason.selectedReasonType !== '') {
        ACC.newOrderReason.displayIpTable();
      }
    }

    if (ACC.newOrderReason.smaxFlow !== 'true' &&
     ACC.newOrderReason.serialNumberfieldlist.includes(ACC.newOrderReason.selectedReasonType)) {
      $('.ph-serialnumber_search').trigger('click');
    }

    if ($('.ph-isEmbargoCountry').text() === 'true') {
      $('.ph-serialnumber_search,.ph-serialNumlabel').addClass('hidden');
      $('.ph-embargoSerialNumlabel').removeClass('hidden');
    }
  });
}

if ($('.ph-orderreasonpage').length > 0) {
  $(window).on('pageshow', function(event) {
    if (event.originalEvent && event.originalEvent.persisted && $('.ph-orderreasonpage').length > 0) {
      window.location.href = escape(ACC.config.contextPath + '/orderReason');
    }
  });
}
